
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";
import Trans from "next-translate/Trans";

import { Head } from "@/components/Head";
import { useTheme } from "@/hooks/useTheme";
import { Converter } from "@/containers/Converter";

import { MagicianSection } from "@/sections/MagicianSection";
import { TrustedBySection } from "@/sections/TrustedBySection";
import { SelectFormatSection } from "@/sections/SelectFormatSection";
import { ApiTeaserSection } from "@/sections/ApiTeaserSection";
import { ConversionSection } from "@/sections/ConversionSection";
import { ShareDesignSection } from "@/sections/ShareDesignSection";

const FigmaToPowerpoint = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  return (
    <>
      <Head
        pageNamespace="page/FigmaToPowerpoint"
        ogImage="/images/figma2powerpoint-og-image.jpg"
      />

      <MagicianSection
        title={t("page/FigmaToPowerpoint:title")}
        subtitle={t("page/FigmaToPowerpoint:subtitle")}
        // TODO: the glow is not working in Chrome
        magicianLogoFile="powerpoint"
        cta={{
          title: t("section/magicians:seeHowItWorks"),
          scrollToId: "ApiTeaserSection",
        }}
      >
        <Converter disabled />
      </MagicianSection>

      <TrustedBySection />

      <ApiTeaserSection
        title={
          ((
            <Trans
              i18nKey="page/FigmaToPowerpoint:section/apiTeaser.title"
              components={[<span style={{ color: colors.ORANGE }} key={0} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/figma-to-powerpoint.png",
          alt: "Figma to Powerpoint converter example",
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("common:actions.signUp"),
        }}
        elements={t(
          "page/FigmaToPowerpoint:section/apiTeaser.apiTeaserElements",
          null,
          {
            returnObjects: true,
          },
        )}
      />
      <ShareDesignSection
        id="ShareDesignSection"
        title={
          ((
            <Trans
              i18nKey="page/FigmaToPowerpoint:section/shareDesign.title"
              components={[<span key="0" style={{ color: colors.ORANGE }} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/import-figma-into-powerpoint.png",
          alt: t("page/FigmaToPowerpoint:section/shareDesign.imageAlt"),
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("page/FigmaToPowerpoint:section/shareDesign.ctaButton"),
        }}
        elements={[
          {
            id: "ELEMENT#1",
            iconType: "SPREAD-ICON",
            title: t(
              "page/FigmaToPowerpoint:section/shareDesign.elements.pathElementsTitle",
            ),
            text: t(
              "page/FigmaToPowerpoint:section/shareDesign.elements.pathElementsText",
            ),
          },
          {
            id: "ELEMENT#2",
            iconType: "FOLDER-SIMPLE-ICON",
            title: t(
              "page/FigmaToPowerpoint:section/shareDesign.elements.folderStructureTitle",
            ),
            text: t(
              "page/FigmaToPowerpoint:section/shareDesign.elements.folderStructureText",
            ),
          },
          {
            id: "ELEMENT#3",
            iconType: "CHECK-GREEN-ICON",
            title: t(
              "page/FigmaToPowerpoint:section/shareDesign.elements.imageSupportTitle",
            ),
            text: t(
              "page/FigmaToPowerpoint:section/shareDesign.elements.imageSupportText",
            ),
          },
        ]}
      />

      <ConversionSection
        title={t("section/conversion:title")}
        iconBadges={[
          {
            iconType: "SHEETS",
            text: t("section/conversion:badges.supportsAll"),
          },
          {
            iconType: "CHECK-GREEN-ICON",
            text: t("section/conversion:badges.accuracy"),
          },
        ]}
        elements={{
          from: {
            iconType: "FIGMA",
            image: "/images/figma-preview-slides-new.jpg",
            title: "Figma Demo Preview",
          },
          to: {
            iconType: "POWERPOINT",
            image: "/images/powerpoint-preview.jpg",
            title: "PowerPoint Demo Preview",
          },
        }}
      />

      <SelectFormatSection title={t("section/selectFormat:title")} />
    </>
  );
};

// Temporal workaround for https://github.com/vercel/next.js/discussions/18396
 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default FigmaToPowerpoint;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/converter/figma-to-powerpoint',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  